module.exports = require("@swa-ui/browser/src/assets/styles/sass/defines/_mediaQueries.module.scss");